export function karmaIconColor(score, minimum = -20) {
  if (typeof score !== 'number' || score >= 0) return null;

  const range = Math.max(1, -Number(minimum) || 20);
  const severity = Math.min(-score, range) / range;
  const hue = Math.round(30 * (1 - Math.min(severity * 2, 1)));
  const lightness = Math.round(52 - 22 * severity);
  return `hsl(${hue} 85% ${lightness}%)`;
}
